import VueRouter from 'vue-router';
import Vue from 'vue';
import { asyncRoutes } from './routes';
import { createGuard } from './guard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/virtualControl/x7/index',
    component: () => import('@/views/virtualControl/x7/index'),
    meta: {
      title: '主页',
    },
  },
  ...asyncRoutes,
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_URL,
  routes,
});

createGuard(router);

export default router;
